/** Sidebar navigation for individual product pages (EN + ES).
 * Piston pumps open into A10V, C11/H20/H80, and PVE/PVH/PVQ/PVB.
 * Vane pumps open into Vickers and Racine styles.
 * Gear pumps open into aluminum pumps and C101 / C102.
 * Cylinders open into NFPA, AG, telescopic, and special.
 */

export const PRODUCTS_NAV = {
	en: {
		title: "Products",
		allHref: "/en/products",
		sections: [
			{
				id: "pumps",
				label: "Pumps",
				links: [
					{
						id: "piston-pumps",
						label: "Piston Pumps",
						children: [
							{
								label: "A10V / A4V",
								href: "/en/products/hydraulics/pumps/piston_pumps/series_a10v_a4v",
							},
							{
								label: "C11/H20/H80",
								href: "/en/products/hydraulics/pumps/piston_pumps/c11_h20_h80",
							},
							{
								label: "PVE/PVH/PVQ/PVB",
								href: "/en/products/hydraulics/pumps/piston_pumps/series_pve_pvh_pvq_pvb",
							},
						],
					},
					{
						id: "vane-pumps",
						label: "Vane Pumps",
						matchPrefix: "/en/products/hydraulics/pumps/vane-pumps",
						children: [
							{
								label: "Vickers Style",
								href: "/en/products/hydraulics/pumps/vane-pumps/vickers-style",
							},
							{
								label: "Racine Style",
								href: "/en/products/hydraulics/pumps/vane-pumps/racine-style",
							},
						],
					},
					{
						id: "gear-pumps",
						label: "Gear Pumps",
						matchPrefix: "/en/products/hydraulics/pumps/gear-pumps",
						children: [
							{
								label: "Aluminum pumps",
								href: "/en/products/hydraulics/pumps/gear-pumps/aluminum",
							},
							{
								label: "C101 / C102",
								href: "/en/products/hydraulics/pumps/gear-pumps/c101-c102",
							},
						],
					},
				],
			},
			{
				id: "motors",
				label: "Motors",
				links: [
					{ label: "Geroler Motors", href: "/en/products/hydraulics/motors/geroler-motors" },
					{ label: "Vane Motors", href: "/en/products/hydraulics/motors/vane-motors" },
					{ label: "Piston Motors", href: "/en/products/hydraulics/motors/piston-motors" },
				],
			},
			{
				id: "valves",
				label: "Valves",
				subtitle: "Industrial Valves",
				links: [
					{
						label: "Directional Control",
						href: "/en/products/hydraulics/industrial-valves/directional-control-valves",
					},
					{
						label: "Flow Control",
						href: "/en/products/hydraulics/industrial-valves/flow-control-valves",
					},
					{
						label: "Pressure Control",
						href: "/en/products/hydraulics/industrial-valves/pressure-control-valves",
					},
					{
						label: "Modular Valves",
						href: "/en/products/hydraulics/industrial-valves/modular-valves",
					},
				],
			},
			{
				id: "cylinders",
				label: "Cylinders",
				links: [
					{
						id: "cylinders",
						label: "Cylinders",
						matchPrefix: "/en/products/hydraulics/cylinders",
						children: [
							{
								label: "NFPA Cylinders",
								href: "/en/products/hydraulics/cylinders/nfpa-cylinders",
							},
							{
								label: "AG Cylinders",
								href: "/en/products/hydraulics/cylinders/AG-cylinders",
							},
							{
								label: "Telescopic Cylinders",
								href: "/en/products/hydraulics/cylinders/telescopic-cylinders",
							},
							{
								label: "Special Cylinders",
								href: "/en/products/hydraulics/cylinders/special-cylinders",
							},
						],
					},
				],
			},
			{
				id: "manifolds",
				label: "Manifolds",
				links: [{ label: "Manifolds", href: "/en/products/hydraulic-manifolds" }],
			},
			{
				id: "filters",
				label: "Filters",
				links: [
					{
						label: "Filter Elements",
						href: "/en/products/hydraulics/filter-elements",
						matchPrefix: true,
					},
				],
			},
			{
				id: "linearBearings",
				label: "Linear Bearings",
				links: [
					{
						label: "Linear Bearings",
						href: "/en/products/mechanical/linear-bearings",
					},
				],
			},
			{
				id: "ballScrews",
				label: "Ball Screws",
				links: [{ label: "Ball Screws", href: "/en/products/mechanical/ball-screws" }],
			},
		],
	},
	es: {
		title: "Productos",
		allHref: "/es/productos",
		sections: [
			{
				id: "pumps",
				label: "Bombas",
				links: [
					{
						id: "piston-pumps",
						label: "Bombas de pistón",
						children: [
							{
								label: "A10V / A4V",
								href: "/es/productos/hidraulicos/bombas/bombas_de_pistones/series_a10v_a4v",
							},
							{
								label: "C11/H20/H80",
								href: "/es/productos/hidraulicos/bombas/bombas_de_pistones/c11_h20_h80",
							},
							{
								label: "PVE/PVH/PVQ/PVB",
								href: "/es/productos/hidraulicos/bombas/bombas_de_pistones/series_pve_pvh_pvq_pvb",
							},
						],
					},
					{
						id: "vane-pumps",
						label: "Bombas de paletas",
						matchPrefix: "/es/productos/hidraulicos/bombas/bombas-de-paletas",
						children: [
							{
								label: "Estilo Vickers",
								href: "/es/productos/hidraulicos/bombas/bombas-de-paletas/estilo-vickers",
							},
							{
								label: "Estilo Racine",
								href: "/es/productos/hidraulicos/bombas/bombas-de-paletas/estilo-racine",
							},
						],
					},
					{
						id: "gear-pumps",
						label: "Bombas de engranajes",
						matchPrefix: "/es/productos/hidraulicos/bombas/bombas-de-engranajes",
						children: [
							{
								label: "Bombas de aluminio",
								href: "/es/productos/hidraulicos/bombas/bombas-de-engranajes/bombas_de_aluminio",
							},
							{
								label: "C101 / C102",
								href: "/es/productos/hidraulicos/bombas/bombas-de-engranajes/c101_c102",
							},
						],
					},
				],
			},
			{
				id: "motors",
				label: "Motores",
				links: [
					{
						label: "Motores orbitales",
						href: "/es/productos/hidraulicos/motores/motores-hidraulicos-orbitales",
					},
					{
						label: "Motores de paletas",
						href: "/es/productos/hidraulicos/motores/motores-de-paletas",
					},
					{
						label: "Motores de pistones",
						href: "/es/productos/hidraulicos/motores/motores_de_pistones",
					},
				],
			},
			{
				id: "valves",
				label: "Válvulas",
				subtitle: "Válvulas industriales",
				links: [
					{
						label: "Control direccional",
						href: "/es/productos/hidraulicos/valvulas/industriales/control_de_direccion/valvulas_direccionales_hidraulicas",
					},
					{
						label: "Control de caudal",
						href: "/es/productos/hidraulicos/valvulas/industriales/control_de_caudal/valvulas-de-control-de-caudal",
					},
					{
						label: "Control de presión",
						href: "/es/productos/hidraulicos/valvulas/industriales/control_de_presion/valvulas_control_de_presion",
					},
					{
						label: "Válvulas modulares",
						href: "/es/productos/hidraulicos/valvulas/industriales/valvulas_modulares/valvulas_stack",
					},
				],
			},
			{
				id: "cylinders",
				label: "Cilindros",
				links: [
					{
						id: "cylinders",
						label: "Cilindros",
						matchPrefix: "/es/productos/hidraulicos/cilindros_hidraulicos",
						children: [
							{
								label: "Cilindros NFPA",
								href: "/es/productos/hidraulicos/cilindros_hidraulicos/nfpa",
							},
							{
								label: "Cilindros AG",
								href: "/es/productos/hidraulicos/cilindros_hidraulicos/cilindros_agricolas",
							},
							{
								label: "Cilindros telescópicos",
								href: "/es/productos/hidraulicos/cilindros_hidraulicos/cilindros_telescopicos",
							},
							{
								label: "Cilindros especiales",
								href: "/es/productos/hidraulicos/cilindros_hidraulicos/cilindros_especiales",
							},
						],
					},
				],
			},
			{
				id: "manifolds",
				label: "Manifolds",
				links: [
					{
						label: "Manifolds hidráulicos",
						href: "/es/productos/hidraulicos/manifolds/manifolds-hidraulicos",
					},
				],
			},
			{
				id: "filters",
				label: "Filtros",
				links: [
					{
						label: "Elementos filtrantes",
						href: "/es/productos/elementos-filtrantes",
						matchPrefix: true,
					},
				],
			},
			{
				id: "linearBearings",
				label: "Guías lineales",
				links: [
					{
						label: "Guías lineales",
						href: "/es/productos/mecanicos/guias-lineales",
					},
				],
			},
			{
				id: "ballScrews",
				label: "Husillos de bolas",
				links: [
					{
						label: "Husillos de bolas",
						href: "/es/productos/mecanicos/husillos-de-bolas",
					},
				],
			},
		],
	},
};

export function isProductsNavLinkActive(path, link) {
	if (!path || !link?.href) return false;
	if (link.matchPrefix) {
		return path === link.href || path.startsWith(`${link.href}/`);
	}
	return path === link.href;
}
